import { ErrorModel } from "src/models/ErrorModel.model";
import apiUrl from "../config/apiUrl";
import { ProfileModel } from "../models/Profile.model";
import { UserCheckNumberModel } from "../models/request/UserCheckNumber.model";
import { UserCheckOtoModel } from "../models/request/UserCheckOtp.model";
import { UserLoginModel } from "../models/request/UserLogin.model";
import fetchUrl from "../utils/fetchUrl";

export const USER_CHECK_NUMBER = async (data: UserCheckNumberModel) => {
  return await fetchUrl({
    url: `${apiUrl}users/checkNumberByRecaptcha`,
    method: "POST",
    body: data,
  });
};
export const USER_CHECK_OTP = async (data: UserCheckOtoModel) => {
  return await fetchUrl({
    url: `${apiUrl}users/checkOtp`,
    method: "POST",
    body: data,
  });
};

export const USER_LOGIN_WITHOUT_OTP = async (data: UserCheckOtoModel) => {
  return await fetchUrl({
    url: `${apiUrl}users/loginWithMobile`,
    method: "POST",
    body: data,
  });
};

export const USER_LOGIN = async (data: UserLoginModel) => {
  return await fetchUrl({
    url: `${apiUrl}users/login`,
    method: "POST",
    body: data,
  });
};
export const USER_OTP_FOR_LOGIN = async (mobileNumber: string) => {
  return await fetchUrl({
    url: `${apiUrl}users/otpForLogin`,
    method: "POST",
    body: { mobileNumber },
  });
};
export const USER_SET_REFERRAL = async (referralCode: string | undefined) => {
  return await fetchUrl({
    url: `${apiUrl}users/setReferral?referralCode=${referralCode}`,
    method: "POST",
    body: {},
  });
};
export const USER_LOGIN_HISTORY = async () => {
  return await fetchUrl({
    url: `${apiUrl}users/loginHistory?page=${0}&size=${1000}`,
    method: "GET",
  });
};
export const USER_OTP_SECOND = async (mobileNumber: string) => {
  return await fetchUrl({
    url: `${apiUrl}users/otpSecond?mobileNumber=${mobileNumber}`,
    method: "GET",
  });
};
export const USER_OTP_FOR_CHANGE_PASS = async () => {
  return await fetchUrl({
    url: `${apiUrl}users/otpForChangePassword`,
    method: "POST",
    body: {},
  });
};
export const USER_CHANGE_PASS = async (data: any) => {
  return await fetchUrl({
    url: `${apiUrl}users/changePassword`,
    method: "POST",
    body: data,
  });
};
export const USER_UPDATE_PROFILE = async (user: ProfileModel) => {
  return await fetchUrl({
    url: `${apiUrl}profile`,
    method: "PUT",
    body: user,
  });
};
export const USER_ERROR = async (data: ErrorModel) => {
  return await fetchUrl({
    url: `${apiUrl}users/sendError`,
    method: "POST",
    body: data,
  });
};
